// extracted by mini-css-extract-plugin
export default {"button":"BorderlessButton_button__9-Unz","disabled":"BorderlessButton_disabled__euKaM"};